import type { TennisFragment } from '@ps/web-shared-generated-graphql/sports';
import React from 'react';

interface PreviousSetsScoreProps {
  previousSets: TennisFragment['previousSets'];
}

const PreviousSetsScore: React.FC<PreviousSetsScoreProps> = ({ previousSets }) => (
  <span>
    {previousSets?.map((previousSet) => `(${previousSet?.teamAScore}-${previousSet?.teamBScore}) `)}
  </span>
);

export default PreviousSetsScore;
